import React from 'react';
import PropTypes from 'prop-types';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

const DataTableColumnSort = ({ active, direction = 'asc', onOrderClick }) => {
  const classes = ['icon'];
  if (!active) {
    classes.push('inactive');
  }
  if (direction === 'desc') {
    classes.push('reversed');
  }

  return <ArrowUpwardIcon className={classes.join(' ')} onClick={onOrderClick} />;
};

DataTableColumnSort.propTypes = {
  active: PropTypes.bool,
  direction: PropTypes.oneOf(['asc', 'desc']),
  onClickOrder: PropTypes.func,
  onOrderClick: PropTypes.func,
};

export default DataTableColumnSort;
